// extracted by mini-css-extract-plugin
export default {"handle":"handle--iYqu9"};